// test2502
(2502 && 0);
